import CurrentAPY from 'features/accounts/CurrentApy/CurrentApy';
import React from 'react';

const CurrentAPYWrapper = () => {
  return <CurrentAPY />;
};

export default CurrentAPYWrapper;
